
import { TranslationRecord } from '../../types';

export const about: TranslationRecord = {
  // About Section
  aboutTitle: 'What Sets Us Apart',
  aboutDescription: 'Located in the vibrant center of Thessaloniki, Loena Luxury Suites offers premium accommodation with a blend of modern luxury and comfort.',
  ourLocation: 'Central location in Thessaloniki',
  surroundedByRestaurants: 'Top restaurants within walking distance',
  climateControl: 'Climate control (A/C and heating)',
  fullyEquippedKitchen: 'Fully equipped modern kitchen',
  highSpeedWifi: 'High-speed Wi-Fi (100 Mbps)',
  personalizedAttention: 'Personalized attention',
  dailyHousekeeping: 'Daily housekeeping service',
  exceptionalStay: 'At Loena Luxury Suites, we ensure your stay is nothing short of exceptional.',
  ourAmenities: 'Our Amenities',
  ourHistory: 'Our History',
};
